import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    $(document).ready(function () {
        var selector = "[data-count]";
        gsap.registerPlugin(ScrollTrigger);

        if ($(selector).length) {
            if (log) console.log("%cfunction_count.js initialized", "color: green;");

            function countUp($element, duration = 2000) {
                const target = +$element.attr("data-count");
                const start = 0;
                const startTime = performance.now();

                function update(currentTime) {
                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const value = Math.floor(progress * (target - start) + start);
                    $element.text(value);

                    if (progress < 1) {
                        requestAnimationFrame(update);
                    }
                }

                requestAnimationFrame(update);
            }

            function reset($element) {
                $element.html("0");
            }

            $(selector).each(function () {
                var $instance = $(this);

                ScrollTrigger.create({
                    scroller: window,
                    trigger: $instance[0],
                    start: "top bottom-=25%",
                    endTrigger: "html",
                    end: "bottom top",
                    once: true,
                    onToggle: function (_self) {
                        if (_self.isActive) {
                            countUp($instance);
                        } else {
                            // reset($instance);
                        }
                    },
                    toggleActions: "play reverse play reverse",
                });
            });
        }
    });
})();
